import { useContext } from "react";
import { LoadingContext } from "../contexts/loadingContext";

export const useLoading = () => {
  const context = useContext(LoadingContext);

  return context;
};
